
import { Component} from '@angular/core';

// -----------------------------------------------------------------------------------------
@Component({
  selector: 'lib-generated-svg',
  templateUrl: './contract-generated.component.svg',
})
export class ContractGeneratedSvgComponent {
  
}
